module.exports = __webpack_public_path__ + "static/img/3.165daf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-terrestre-carga/3.png
// module id = rSxV
// module chunks = 0